import { render, staticRenderFns } from "./observation-icon.component.vue?vue&type=template&id=4908c4f4&scoped=true&"
import script from "./observation-icon.component.vue?vue&type=script&lang=ts&"
export * from "./observation-icon.component.vue?vue&type=script&lang=ts&"
import style0 from "./observation-icon.component.vue?vue&type=style&index=0&id=4908c4f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4908c4f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
